import { Attr, BelongsTo, Model } from 'spraypaint';

import { ApplicationRecord } from './application_record';
import Facility from './facility';

@Model()
export default class Keypair extends ApplicationRecord {
  static jsonapiType = 'keypairs';
  @Attr() name: string;
  @Attr() fingerprint: string;
  @Attr({ persist: false }) selected: boolean;
  @Attr() default: boolean;

  @BelongsTo() facility: Facility;

  constructor(attrs?: Record<string, any>) {
    super(attrs);
    this.selected = false;
  }
}
